export type OpenFinanceQueueFilter = 'pending' | 'review_required' | 'duplicate_suspected' | 'ignored' | 'history';

/** Estimated elapsed-time feedback. Never show 100% before the API actually finishes. */
export function boundedSyncProgress(elapsedMs: number): number {
  return Math.max(0, Math.min(95, Math.floor(elapsedMs / 1000) + (elapsedMs > 0 ? 1 : 0)));
}

export function buildQueuePath(filter: OpenFinanceQueueFilter): string {
  return `/movimentacoes/reviews?filter=${encodeURIComponent(filter)}`;
}

export function toggleSelection(selected: ReadonlySet<string>, reviewId: string): Set<string> {
  const next = new Set(selected);
  if (next.has(reviewId)) next.delete(reviewId);
  else next.add(reviewId);
  return next;
}

export function visibleSelection(selected: ReadonlySet<string>, visibleReviewIds: readonly string[]): string[] {
  return visibleReviewIds.filter((reviewId) => selected.has(reviewId));
}

export function safeReviewIds(groups: readonly { items: readonly { id: string; bulkSafe: boolean }[] }[]): string[] {
  return groups.flatMap((group) => group.items.filter((item) => item.bulkSafe).map((item) => item.id));
}

export function counterpartyTypeLabel(value: string): string {
  const normalized = value.trim().toLocaleUpperCase('pt-BR');
  if (normalized === 'INDIVIDUAL' || normalized === 'PERSON' || normalized === 'NATURAL_PERSON') return 'Pessoa física';
  if (normalized === 'LEGAL_ENTITY' || normalized === 'COMPANY' || normalized === 'BUSINESS') return 'Pessoa jurídica';
  return value;
}

export function operationTypeLabel(value: string): string {
  const normalized = value.trim().toLocaleUpperCase('pt-BR');
  if (normalized === 'PIX') return 'Pix';
  return normalized;
}

export function bulkResultMessage(input: {
  approvedCount: number;
  skippedCount: number;
  failedCount: number;
}): string {
  const parts: string[] = [];
  if (input.approvedCount > 0) {
    parts.push(`${input.approvedCount} aprovada${input.approvedCount === 1 ? '' : 's'}${input.approvedCount === 1 ? ' com sucesso.' : ''}`);
  }
  if (input.skippedCount > 0) {
    parts.push(`${input.skippedCount} ignorada${input.skippedCount === 1 ? '' : 's'} por segurança`);
  }
  if (input.failedCount > 0) {
    parts.push(`${input.failedCount} com falha`);
  }
  if (parts.length === 0) return 'Nenhuma movimentação foi alterada.';
  if (parts.length === 1) return parts[0]!;
  return `${parts.slice(0, -1).join(', ')} e ${parts.at(-1)}.`;
}
